module.exports = __webpack_public_path__ + "static/media/img-05.87ec2522.jpg";